export interface ExportColumn {
  name: string;
  displayName: string;
}

/**
 * Maps the grid's ordered visible column keys to their backend export column
 * definitions, preserving the display order and dropping keys with no mapping.
 * Falls back to every mapped column when no keys have been captured yet.
 */
export function resolveExportColumns(
  orderedVisibleKeys: string[] | null,
  columnMap: Record<string, ExportColumn>,
): ExportColumn[] {
  if (!orderedVisibleKeys) return Object.values(columnMap);

  return orderedVisibleKeys
    .map((key) => columnMap[key])
    .filter((col): col is ExportColumn => col !== undefined);
}
